import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  onPressDashbord,
  onPressDashbordChild,
  onPressEqualizer,
  closeHeaderMenus,
  onPressGeneralSetting,
  onPressMenuProfileDropdown,
  onPressNotification,
  onPressSideMenuTab,
  onPressSideMenuToggle,
  onPressThemeColor,
  tostMessageLoad,
  updateUserInfo,
} from "../actions";
import { handleLogout } from "../helpers/AuthHelper";
import Logo from "../assets/images/logo-black.png";
import LogoWhite from "../assets/images/logo-white.png";
import mainHelper, { apiCall, getTotalDatas } from "../helpers/MainHelper";
import withPermissions from "./WithPermissions";
import Swal from "sweetalert2";
import axios from "axios";
import subscriptionPermissionsControl from "./SubscriptionPermissionsControl";
import NotificationService from "../services/NotificationService";

// Sub-components
import SidebarMenu from "./SidebarMenu";
import NotificationDropdown from "./navbar/NotificationDropdown";
import { AssistantLauncher } from "./Assistant/Assistant";
import SearchPlateModal from "./navbar/SearchPlateModal";
import ConversationsPanel from "./navbar/ConversationsPanel";
import ThemeSettings from "./navbar/ThemeSettings";
import SupportTicketForm from "./navbar/SupportTicketForm";
import UserAccountPanel from "./navbar/UserAccountPanel";
import "./NavigationPremium.css";
import { DASHBOARD_CHANGED } from '../helpers/DashboardRefresh';
import { createMobileSidebarScrollLock } from '../helpers/MobileSidebarScrollLock';

export class NavbarMenu extends React.Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.headerRef = React.createRef();
    this.state = {
      showSearchModel: false,
      totalServices: '',
      totalCustomers: '',
      totalRevenue: '',
      notifications: [],
      isLoad: false,
      loading: false,
      deleteAllNotifyLoading: false,
      deleteLoading: {},
      plateFindloading: false,
      ticketFormData: { title: '', description: '' },
      conversations: [],
      isLoadingConversations: false,
      unreadMessageCount: 0,
    };
  }

  // ─── Lifecycle ──────────────────────────────────────
  componentDidMount() {
    this.closeHeaderMenus();
    document.addEventListener('click', this.handleHeaderOutsideClick, true);
    document.addEventListener('keydown', this.handleHeaderKeyDown);
    window.addEventListener('pageshow', this.closeHeaderMenus);
    this.sidebarScrollLock = createMobileSidebarScrollLock();
    this.summaryActive = true;
    this.summaryController = new AbortController();
    window.addEventListener(DASHBOARD_CHANGED, this.scheduleSummaryRefresh);
    this.props.tostMessageLoad(true);
    this.activeMenutabwhenNavigate(this.props.activeKey);
    this.navigationLocation = this.props.history?.location;
    if (this.props.history?.listen) this.unlistenNavigation = this.props.history.listen(this.handleRouteChange);

    if (localStorage.getItem('isLoggedIn') === 'true') {
      this.getTotalDatas();
      this.initializePushNotifications();

      NotificationService.setNotificationClickHandler((data) => this.handleNotificationClick(data));
      NotificationService.startPolling(async (signal) => {
        if (localStorage.getItem('isLoggedIn') === 'true') {
          await Promise.all([this.getAppNotification(signal), this.loadConversations(false, signal)]);
        }
      }, 30000);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleHeaderOutsideClick, true);
    document.removeEventListener('keydown', this.handleHeaderKeyDown);
    window.removeEventListener('pageshow', this.closeHeaderMenus);
    this.closeHeaderMenus();
    if (this.unlistenNavigation) this.unlistenNavigation();
    this.closeMobileSidebar({ restorePosition: false });
    if (this.sidebarScrollLock) this.sidebarScrollLock.dispose({ restorePosition: false });
    this.summaryActive = false;
    window.removeEventListener(DASHBOARD_CHANGED, this.scheduleSummaryRefresh);
    clearTimeout(this.summaryTimer);
    if (this.summaryController) this.summaryController.abort();
    NotificationService.stopPolling();
  }

  // ─── Data Loaders ───────────────────────────────────
  scheduleSummaryRefresh = () => {
    if (!this.summaryActive) return;
    this.summaryDirty = true;
    clearTimeout(this.summaryTimer);
    this.summaryTimer = setTimeout(() => this.getTotalDatas(), 250);
  };

  getTotalDatas = async () => {
    if (!this.summaryActive || this.summaryInFlight || localStorage.getItem('isLoggedIn') !== 'true') return;
    this.summaryInFlight = true;
    this.summaryDirty = false;
    try {
      const response = await getTotalDatas({ background: true, signal: this.summaryController?.signal });
      if (!this.summaryActive) return;
      this.setState({
        totalService: response.totalService || 0,
        totalCustomers: response.totalCustomer || 0,
        totalSuppliers: response.totalSupplier || 0,
        totalRevenue: response.totalRevenue || 0,
      }, () => this.setState({ isLoad: true }));
    } catch (error) { if (error.code !== 'ERR_CANCELED') console.error('Summary fetch failed:', error); }
    finally {
      this.summaryInFlight = false;
      if (this.summaryDirty && this.summaryActive) this.scheduleSummaryRefresh();
    }
  }

  loadConversations = async (showLoading = false, signal) => {
    if (this.conversationsInFlight) return;
    this.conversationsInFlight = true;
    try {
      if (showLoading) this.setState({ isLoadingConversations: true });
      const response = await apiCall("business/messages/conversations", "get", null, { background: true, signal });
      if (signal && signal.aborted) return;
      let conversations = [];
      if (response?.data && Array.isArray(response.data)) {
        conversations = response.data;
      } else if (Array.isArray(response)) {
        conversations = response;
      }
      const unreadCount = conversations.reduce((total, conv) => total + (conv.unread_count || 0), 0);
      this.setState({ conversations, isLoadingConversations: false, unreadMessageCount: unreadCount });
    } catch (error) {
      if (error.code === 'ERR_CANCELED') return;
      console.error("Error loading conversations:", error);
      this.setState({ isLoadingConversations: false });
    } finally {
      this.conversationsInFlight = false;
    }
  };

  // ─── Notifications ──────────────────────────────────
  initializePushNotifications = async () => {
    try {
      const permissionStatus = NotificationService.getPermissionStatus();
      if (permissionStatus === 'denied') return;
      await NotificationService.initialize();
    } catch (error) {
      console.error('Error initializing push notifications:', error);
    }
  }

  handleNotificationClick = (data) => {
    if (data.type === 'appointment') window.location.href = `/appointments/${data.appointment_id}`;
    else if (data.type === 'message') window.location.href = `/messages/${data.customer_id || data.user_id}`;
    else if (data.type === 'operation_status') window.location.href = `/operations/${data.operation_id}`;
    else if (data.url) window.location.href = data.url;
    else this.getAppNotification();
  }

  getAppNotification = async (signal) => {
    if (this.notificationsInFlight) return;
    this.notificationsInFlight = true;
    try {
      const response = await apiCall('business/notifications/app/get', 'get', null, { background: true, signal });
      if (signal && signal.aborted) return;
      try {
        const stockAlertsResponse = await apiCall('business/stock/alert/list?size=50&is_read=0', 'get', null, { background: true, signal });
        if (signal && signal.aborted) return;
        const stockAlerts = stockAlertsResponse.data || [];
        const formattedStockAlerts = stockAlerts.map(alert => ({
          id: `stock-${alert.id}`, type: 'stock_alert', message: alert.message,
          created_at: alert.created_at, is_read: alert.is_read ? 1 : 0,
          stock_alert_id: alert.id, stock_alert_type: alert.alert_type,
          warehouse_id: alert.warehouse_id, stock_item_id: alert.stock_item_id,
        }));
        const allNotifications = [...response, ...formattedStockAlerts].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        this.setState({ notifications: allNotifications });
      } catch (stockError) {
        if (stockError.code === 'ERR_CANCELED') return;
        console.error('Stock alerts fetch error:', stockError);
        this.setState({ notifications: response });
      }
    } catch (e) { console.error(e); }
    finally { this.notificationsInFlight = false; }
  }

  detailAndMarkAsRead = async (href, id, isStockAlert = false, stockAlertId = null) => {
    this.closeHeaderMenus();
    try {
      if (isStockAlert && stockAlertId) {
        await apiCall(`business/stock/alert/mark-read/${stockAlertId}`, 'post', null);
      } else {
        await apiCall('business/notifications/app/mark-as-read/' + id, 'get', null);
      }
      window.location.href = href;
    } catch (e) { console.error(e); }
  }

  deleteAllNotifications = async () => {
    try {
      this.setState({ deleteAllNotifyLoading: true });
      const response = await apiCall('business/notifications/app/delete-all', 'delete', null);
      this.setState({ deleteAllNotifyLoading: false }, () => this.getAppNotification());
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      console.error(e);
      this.setState({ deleteAllNotifyLoading: false });
    }
  }

  deleteAppNotify = async (id, isStockAlert = false, stockAlertId = null) => {
    try {
      this.setState(prev => ({ deleteLoading: { ...prev.deleteLoading, [id]: true } }));
      if (isStockAlert && stockAlertId) {
        const response = await apiCall(`business/stock/alert/delete/${stockAlertId}`, 'delete', null);
        mainHelper.toastMessage(response.status, response.message || 'Stok uyarısı silindi');
      } else {
        const response = await apiCall('business/notifications/app/delete/' + id, 'delete', null);
        mainHelper.toastMessage(response.status, response.message);
      }
      this.setState(prev => {
        const updated = { ...prev.deleteLoading };
        delete updated[id];
        return { deleteLoading: updated };
      });
      this.getAppNotification();
    } catch (e) {
      this.setState(prev => ({ deleteLoading: { ...prev.deleteLoading, [id]: false } }));
      console.error(e);
    }
  }

  // ─── Plate Search ───────────────────────────────────
  handleInputChange = (e) => this.setState({ [e.target.name]: e.target.value });
  handleButtonClick = () => this.fileInputRef.current.click();

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) this.getVehiclesPlateWithAI(file);
    event.target.value = null;
  };

  getVehiclesPlateWithAI = async (file) => {
    const modalID = document.getElementById('searchPlateModelContent');
    try {
      Swal.fire({ title: 'Resim işleniyor...', text: 'Lütfen bekleyin, işleminiz devam ediyor.', icon: 'info', allowOutsideClick: false, showConfirmButton: false, target: modalID, willOpen: () => Swal.showLoading() });
      const formData = new FormData();
      formData.append('file', file);
      formData.append('request', JSON.stringify({ "requestedDetectionTypes": ["PLATE"] }));
      const response = await axios.post('https://trafficeye.ai/recognition', formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'apikey': 'af4ee45dfcda333fb4280ca37a3e1049d8573d27fc0b69e88fff58ca64b3614f' }
      });
      const data = response.data.data;
      if (data?.combinations?.length > 0) {
        const vehicleInfo = data.combinations[0].roadUsers[0];
        if (vehicleInfo.plates[0].type.value === "UNK" || vehicleInfo.plates[0].text.score < 0.5) {
          Swal.close();
          Swal.fire({ title: 'Uyarı', text: 'Gönderilen resim uygun değil. Plakanın göründüğünden emin olunuz!', icon: 'warning', confirmButtonText: 'Tamam', target: modalID });
          return;
        }
        const plate = vehicleInfo.plates[0].text?.value || "Bulunamadı";
        if (plate !== "Bulunamadı") {
          const vehicle = await apiCall('business/operation/get-by-plate/' + plate, 'get', null);
          if (vehicle.status === "success") {
            window.location.href = `/vehicle-detail/${vehicle.id}`;
            this.setState({ showSearchModel: false });
          } else {
            Swal.close();
            Swal.fire({ title: 'Araç Bilgileri', text: 'Plakaya Ait Kayıt Bulunamadı.', icon: 'info', confirmButtonText: 'Tamam', target: modalID });
          }
        }
        Swal.close();
      } else {
        Swal.close();
        Swal.fire({ title: 'Araç Bilgileri', text: 'Gönderilen resim uygun değil. Lütfen bir araç resmi yükleyiniz.', icon: 'info', confirmButtonText: 'Tamam', target: modalID });
      }
    } catch (error) {
      Swal.close();
      Swal.fire({ title: 'Araç Bilgileri', text: 'Bir sorun oluştu lütfen daha sonra tekrar deneyiniz!', icon: 'error', confirmButtonText: 'Tamam', target: modalID });
      console.error(error);
    }
  };

  handlePlateSearchSubmit = async (e) => {
    e.preventDefault();
    const modalID = document.getElementById('searchPlateModelContent');
    this.setState({ plateFindloading: true });
    try {
      const vehicle = await apiCall('business/operation/get-by-plate/' + this.state.plate, 'get', null);
      if (vehicle.status === "success") {
        window.location.href = `/vehicle-detail/${vehicle.id}`;
        this.setState({ showSearchModel: false });
      } else {
        Swal.fire({ title: 'Araç Bilgileri', text: 'Plakaya Ait Kayıt Bulunamadı.', icon: 'warning', confirmButtonText: 'Tamam', target: modalID });
      }
      this.setState({ plateFindloading: false, showSearchModel: false });
    } catch (e) {
      this.setState({ plateFindloading: false });
      console.log(e);
    }
  }

  // ─── Ticket ─────────────────────────────────────────
  handleTicketChange = (event) => {
    const { name, value } = event.target;
    this.setState(prev => ({ ticketFormData: { ...prev.ticketFormData, [name]: value } }));
  };

  handleTicketSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    try {
      const response = await apiCall('business/tickets/add', 'post', {
        title: this.state.ticketFormData.title,
        description: this.state.ticketFormData.description,
      });
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) { this.setState({ loading: false }); }
  };

  // ─── Other Actions ──────────────────────────────────
  handleConversationClick = (customerId) => { window.location.href = `/messages/${customerId}`; };

  formatTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const now = new Date();
    const days = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
    if (days === 0) return date.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
    if (days === 1) return "Dün";
    if (days < 7) return date.toLocaleDateString("tr-TR", { weekday: "short" });
    return date.toLocaleDateString("tr-TR", { day: "numeric", month: "short" });
  };

  logout = async (e) => {
    e.preventDefault();
    const result = await Swal.fire({
      title: 'Çıkış yapmak istediğinize emin misiniz?', text: "", icon: 'warning',
      showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
      confirmButtonText: 'Evet', cancelButtonText: 'Hayır, iptal et'
    });
    if (result.isConfirmed) {
      try { this.props.handleLogout(this.props.history); }
      catch (error) { Swal.fire('Hata!', 'İşlem başarısız oldu.', 'error'); }
    }
  }

  syncData = async () => {
    try {
      Swal.fire({ title: 'Veriler güncelleniyor...', text: 'Lütfen bekleyin, işleminiz devam ediyor.', icon: 'info', allowOutsideClick: false, showConfirmButton: false, willOpen: () => Swal.showLoading() });
      const cache = await caches.open('app-cache-v7');
      const token = localStorage.getItem('token');
      const fetchAndCacheData = async (url, cacheKey) => {
        const response = await axios.get(process.env.REACT_APP_API_URL + `${url}`, { headers: { 'Authorization': `Bearer ${token}` } });
        await cache.put(cacheKey, new Response(JSON.stringify(response.data)));
      };
      await Promise.all([
        fetchAndCacheData('business/settings/role/get-roles', '/roles'),
        fetchAndCacheData('business/dashboard/get-total-data', '/totalData'),
        fetchAndCacheData('business/dashboard/get-top-types', '/topTypes'),
        fetchAndCacheData('business/dashboard/get-top-branches', '/topBranches'),
        fetchAndCacheData('business/dashboard/get-datas', '/sparks'),
        fetchAndCacheData('business/dashboard/get-setup-info', '/setupDatas'),
        fetchAndCacheData('business/branches/get-branches', '/branches'),
        fetchAndCacheData('business/user/get-employes', '/employees'),
        fetchAndCacheData('business/operation/type/get-types', '/types'),
        fetchAndCacheData('business/customer/get-customer-by-service', '/customers'),
        fetchAndCacheData('business/operation/status/get-status', '/status'),
        fetchAndCacheData('business/income-expense-categories/local/Gider', '/expenseCategories'),
        fetchAndCacheData('business/income-expense-categories/local/Gelir', '/incomeCategories'),
        fetchAndCacheData('business/income-expense-categories/local/all', '/expenseIncomeCategories'),
      ]);
      Swal.fire({ title: 'İşlem tamamlandı!', text: 'Veriler başarıyla güncellendi.', icon: 'success', confirmButtonText: 'Tamam' });
    } catch (error) {
      Swal.fire({ title: 'Hata!', text: 'Veriler güncellenirken bir hata oluştu.', icon: 'error', confirmButtonText: 'Tamam' });
    }
  }

  // ─── Header Dropdowns ───────────────────────────────
  closeHeaderMenus = () => this.props.closeHeaderMenus?.();

  handleHeaderOutsideClick = (event) => {
    const { toggleNotification, toggleEqualizer } = this.props;
    if (!toggleNotification && !toggleEqualizer) return;
    const dropdown = event.target.closest?.('[data-header-dropdown]');
    if (dropdown && this.headerRef.current?.contains(dropdown)) {
      const name = dropdown.getAttribute('data-header-dropdown');
      if ((name === 'notifications' && toggleNotification) || (name === 'quick-actions' && toggleEqualizer)) return;
    }
    this.closeHeaderMenus();
  };

  handleHeaderKeyDown = (event) => {
    if (event.key !== 'Escape' || (!this.props.toggleNotification && !this.props.toggleEqualizer)) return;
    const name = this.props.toggleNotification ? 'notifications' : 'quick-actions';
    this.closeHeaderMenus();
    const trigger = this.headerRef.current?.querySelector(`[data-header-dropdown="${name}"] > .dropdown-toggle`);
    if (trigger) trigger.focus();
  };

  // ─── Sidebar Menu Logic ─────────────────────────────
  closeMobileSidebar = ({ restorePosition = true } = {}) => {
    // Match the existing sidebar's $break-large (1200px) breakpoint.
    if (window.innerWidth <= 1200) {
      document.body.classList.remove('offcanvas-active');
      if (this.sidebarScrollLock) this.sidebarScrollLock.sync({ restorePosition });
    }
  };

  handleRouteChange = (location) => {
    const previous = this.navigationLocation;
    this.navigationLocation = location;
    if (!previous || previous.pathname !== location.pathname || previous.search !== location.search) {
      this.closeHeaderMenus();
      this.closeMobileSidebar({ restorePosition: false });
    }
  };

  handleNavigationClick = (event) => {
    if ((event.button != null && event.button !== 0) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || !event.currentTarget.contains(link) || link.matches('.has-arrow, [data-toggle="tab"]')) return;
    if (link.closest('[data-header-dropdown="quick-actions"] .dropdown-menu')) this.closeHeaderMenus();
    if (link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    try {
      if (new URL(href, window.location.href).origin !== window.location.origin) return;
      this.closeHeaderMenus();
      // Also close when the user selects the page that is already open.
      this.closeMobileSidebar();
    } catch (error) { /* Non-navigation anchors must not affect the drawer. */ }
  };

  activeMenutabContainer(id) {
    var parents = document.getElementById("main-menu");
    var activeMenu = document.getElementById(id);
    if (!activeMenu) return;
    for (let index = 0; index < parents.children.length; index++) {
      if (parents.children[index].id !== id) {
        parents.children[index].classList.remove("active");
        if (parents.children[index].children[1]) parents.children[index].children[1].classList.remove("in");
      }
    }
    setTimeout(() => {
      activeMenu.classList.toggle("active");
      if (activeMenu.children[1]) activeMenu.children[1].classList.toggle("in");
    }, 10);
  }

  activeSubMenutabContainer(parentId, subId) {
    var parentMenu = document.getElementById(parentId);
    if (!parentMenu) return;
    if (!parentMenu.classList.contains("active")) {
      parentMenu.classList.add("active");
      if (parentMenu.children[1]) parentMenu.children[1].classList.add("in");
    }
    var subMenu = document.getElementById(subId);
    if (!subMenu) return;
    setTimeout(() => {
      subMenu.classList.toggle("active");
      if (subMenu.children[1]) subMenu.children[1].classList.toggle("in");
    }, 10);
  }

  activeMenutabwhenNavigate(activeKey) {
    const menuMap = {
      ServicesContainer: ["/services", "/service-add", "/service-detail", "/services-moto", "/service-moto-add", "/service-moto-detail", "/service-add-ai", "/appointments"],
      CustomerContainer: ["/customers-all", "/customer-add", "/suppliers"],
      VehicleContainer: ["/vehicles", "/vehicle-add"],
      OfferContainer: ["/offers", "/offer-add"],
      IncomeExpenseContainer: ["/incomes", "/expenses", "/income-expense-categories"],
      NotificationsContainer: ["/notifications", "/app-notifications"],
      InvoiceContainer: ["/credits"],
      ReceivableContainer: ["/bank-accounts"],
      SettingsContainer: ["/settings/business", "/settings/subscription", "/settings/subscription/detail", "/settings/qr-generate", "/settings/notifications", "/settings/notification-prefers", "/settings/roles", "/settings/integration-accounts"],
      ConfigureContainer: ["/branches", "/status", "/operation-types", "/users"],
      AdminContainer: ["/admin/pricing-management", "/admin/campaign-management", "/admin/vehicle-avatars", "/admin/vehicle-brands"],
      AppContainer: ["/appinbox", "/appcalendar", "/appcontact", "/apptaskbar", "/search-parts"],
      StockContainer: ["/stock/warehouses", "/stock/items", "/stock/categories", "/stock/movements", "/stock/transfers"],
      TicketContainer: ["/tickets", "/ticket-add"],
    };

    // Sub menus that need delayed opening
    const subMenuMap = {
      ReportsContainer: {
        FinanceReportsSubContainer: ["/finance-reports", "/finance-receivable-report", "/finance-income-expense-report"],
        StockReportsSubContainer: ["/stock/reports/summary", "/stock/reports/warehouse", "/stock/reports/movements", "/stock/reports/low-stock", "/stock/reports/sales"],
      },
      ReceivableContainer: {
        CustomerTransactionsSubContainer: ["/receivables", "/receivable-add"],
        SupplierTransactionsSubContainer: ["/receivables-suppliers", "/receivable-supplier-add", "/supplier-payment-add"],
      },
      InvoiceContainer: {
        ManualInvoiceSubContainer: ["/manual-invoices", "/manual-invoice", "/manual-invoice-detail"],
        ServiceInvoiceSubContainer: ["/service-invoices", "/service-invoices-draft", "/service-invoices-running", "/service-invoices-done", "/service-invoices-cancel", "/service-invoices-error", "/service-invoices-unknown", "/documents"],
      },
    };

    // Direct menu matching
    for (const [containerId, keys] of Object.entries(menuMap)) {
      if (keys.includes(activeKey)) {
        this.activeMenutabContainer(containerId);
        return;
      }
    }

    // Report & sub-menu matching
    const reportKeys = ["/service-reports", "/customer-reports"];
    if (reportKeys.includes(activeKey)) {
      this.activeMenutabContainer("ReportsContainer");
      return;
    }

    for (const [parentId, subs] of Object.entries(subMenuMap)) {
      for (const [subId, keys] of Object.entries(subs)) {
        if (keys.includes(activeKey)) {
          this.activeMenutabContainer(parentId);
          setTimeout(() => this.activeSubMenutabContainer(parentId, subId), 100);
          return;
        }
      }
    }
  }

  // ─── Render ─────────────────────────────────────────
  render() {
    const { themeColor, toggleNotification, toggleEqualizer, sideMenuTab, activeKey, userInfo, userPermissions } = this.props;
    const { totalCustomers, totalSuppliers, totalRevenue, totalService, isLoad, notifications, plateFindloading, deleteAllNotifyLoading } = this.state;

    const permissions = userPermissions || [];
    const adminEmails = process.env.REACT_APP_ADMIN_EMAILS
      ? process.env.REACT_APP_ADMIN_EMAILS.split(',').map(email => email.trim())
      : ['servis@servis.com'];
    const isAdmin = userInfo && userInfo.email && adminEmails.includes(userInfo.email);

    document.body.classList.add(themeColor);

    return (
      <div className="servicezone-navigation" onClick={this.handleNavigationClick}>
        {/* ── Top Navbar ── */}
        <nav className="navbar navbar-fixed-top" ref={this.headerRef}>
          <div className="container-fluid">
            <div className="navbar-btn">
              <button className="btn-toggle-offcanvas" aria-label="Menüyü aç veya kapat" onClick={() => this.props.onPressSideMenuToggle()}>
                <i className="lnr lnr-menu fa fa-bars"></i>
              </button>
            </div>
            <div className="navbar-brand">
              <Link to="/dashboard">
                <img src={document.body.classList.contains("full-dark") ? LogoWhite : Logo} alt="serviszone" className="img-responsive logo" />
              </Link>
            </div>
            <div className="navbar-right">
              <div id="navbar-menu">
                <ul className="nav navbar-nav">
                  <li className="assistant-nav-item"><AssistantLauncher /></li>
                  {/* Notification Dropdown */}
                  <NotificationDropdown
                    notifications={notifications}
                    toggleNotification={toggleNotification}
                    onToggle={() => this.props.onPressNotification()}
                    onDeleteAll={this.deleteAllNotifications}
                    onDelete={this.deleteAppNotify}
                    onDetailAndMarkAsRead={this.detailAndMarkAsRead}
                    deleteAllNotifyLoading={deleteAllNotifyLoading}
                    deleteLoading={this.state.deleteLoading}
                  />

                  {/* Quick Actions Dropdown */}
                  <li className={toggleEqualizer ? "show dropdown" : "dropdown"} data-header-dropdown="quick-actions">
                    <a href="#!" className="dropdown-toggle icon-menu" aria-label="Hızlı işlemler" aria-expanded={toggleEqualizer} aria-haspopup="true" aria-controls="header-quick-actions"
                      onClick={(e) => { e.preventDefault(); this.props.onPressEqualizer(); }}>
                      <i className="icon-list"></i>
                    </a>
                    <ul id="header-quick-actions" hidden={!toggleEqualizer} className={toggleEqualizer ? "dropdown-menu user-menu menu-icon show" : "dropdown-menu user-menu menu-icon"}>
                      <li className="menu-heading">Uygulamalar</li>
                      <li><Link to="/apptaskbar"><i className="icon-grid"></i> <span>İş Akış Panosu</span></Link></li>
                      <li><Link to="/appcalendar"><i className="icon-calendar"></i> <span>Takvim</span></Link></li>
                      <li className="menu-heading">Diğer</li>
                      <li><a onClick={(e) => { e.preventDefault(); this.setState({ showSearchModel: true }); }} href="#!"><i className="icon-magnifier"></i><span>Araç Bul</span></a></li>
                      <li><a onClick={(e) => { e.preventDefault(); this.syncData(); }} href="#!"><i className="icon-reload"></i><span>Verileri Senkronize Et</span></a></li>
                      <li><a href="https://servicezone.com.tr/document" target="_blank" rel="noopener noreferrer"><i className="icon-doc"></i><span>Dökümantasyon</span></a></li>
                      <li><a href="#!" onClick={this.logout}><i className="icon-login"></i><span>Çıkış Yap</span></a></li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>

        {/* ── Search Plate Modal ── */}
        <SearchPlateModal
          show={this.state.showSearchModel}
          onClose={() => this.setState({ showSearchModel: false })}
          onInputChange={this.handleInputChange}
          onSubmit={this.handlePlateSearchSubmit}
          onButtonClick={this.handleButtonClick}
          onFileChange={this.handleFileChange}
          fileInputRef={this.fileInputRef}
          plateFindloading={plateFindloading}
        />

        {/* ── Left Sidebar ── */}
        <div id="left-sidebar" className="sidebar" style={{ zIndex: 9 }}>
          <div className="sidebar-scroll">
            {/* User Account */}
            <UserAccountPanel
              userInfo={userInfo}
              totalService={totalService}
              totalCustomers={totalCustomers}
              totalSuppliers={totalSuppliers}
              totalRevenue={totalRevenue}
              isLoad={isLoad}
            />

            {/* Sidebar Tab Navigation */}
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <Link to="#" className={sideMenuTab[0] ? "nav-link active" : "nav-link"} data-toggle="tab"
                  onClick={(event) => { event.preventDefault(); this.props.onPressSideMenuTab(0); }}>Menu</Link>
              </li>
              <li className="nav-item">
                <Link to="#" className={sideMenuTab[1] ? "nav-link active" : "nav-link"} data-toggle="tab"
                  onClick={(event) => { event.preventDefault(); this.props.onPressSideMenuTab(1); if (!sideMenuTab[1]) this.loadConversations(true); }}
                  style={{ position: "relative" }}>
                  <i className="icon-bubbles"></i>
                  {this.state.unreadMessageCount > 0 && (
                    <span className="badge badge-danger" style={{ position: "absolute", top: "-5px", right: "-5px", fontSize: "10px", padding: "2px 5px", borderRadius: "10px" }}>
                      {this.state.unreadMessageCount > 99 ? "99+" : this.state.unreadMessageCount}
                    </span>
                  )}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="#" className={sideMenuTab[2] ? "nav-link active" : "nav-link"} data-toggle="tab"
                  onClick={(event) => { event.preventDefault(); this.props.onPressSideMenuTab(2); }}>
                  <i className="icon-settings"></i>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="#" className={sideMenuTab[3] ? "nav-link active" : "nav-link"} data-toggle="tab"
                  onClick={(event) => { event.preventDefault(); this.props.onPressSideMenuTab(3); }}>
                  <i className="icon-question"></i>
                </Link>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content p-l-0 p-r-0">
              {/* Menu Tab */}
              <div className={sideMenuTab[0] ? "tab-pane active show" : "tab-pane"} id="menu">
                <SidebarMenu
                  activeKey={activeKey}
                  permissions={permissions}
                  isAdmin={isAdmin}
                  userInfo={userInfo}
                  activeMenutabContainer={(id) => this.activeMenutabContainer(id)}
                  activeSubMenutabContainer={(parentId, subId) => this.activeSubMenutabContainer(parentId, subId)}
                />
              </div>

              {/* Chat Tab */}
              <div className={sideMenuTab[1] ? "tab-pane show active" : "tab-pane"} id="Chat" style={{ padding: 0 }}>
                <ConversationsPanel
                  conversations={this.state.conversations}
                  isLoading={this.state.isLoadingConversations}
                  unreadMessageCount={this.state.unreadMessageCount}
                  onConversationClick={this.handleConversationClick}
                  formatTime={this.formatTime}
                />
              </div>

              {/* Theme Settings Tab */}
              <div className={sideMenuTab[2] ? "tab-pane p-l-15 p-r-15 show active" : "tab-pane p-l-15 p-r-15"} id="setting">
                <ThemeSettings themeColor={themeColor} onThemeChange={(key) => this.props.onPressThemeColor(key)} />
              </div>

              {/* Support Ticket Tab */}
              <div className={sideMenuTab[3] ? "tab-pane p-l-15 p-r-15 show active" : "tab-pane p-l-15 p-r-15"} id="question">
                <SupportTicketForm loading={this.state.loading} onChange={this.handleTicketChange} onSubmit={this.handleTicketSubmit} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NavbarMenu.propTypes = {
  themeColor: PropTypes.string.isRequired,
  toggleNotification: PropTypes.bool.isRequired,
  toggleEqualizer: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ navigationReducer }) => {
  const {
    themeColor, toggleNotification, toggleEqualizer,
    menuProfileDropdown, sideMenuTab, isToastMessage, userInfo,
  } = navigationReducer;
  return {
    themeColor, toggleNotification, toggleEqualizer,
    menuProfileDropdown, sideMenuTab, isToastMessage, userInfo,
  };
};

export default subscriptionPermissionsControl(withPermissions(connect(mapStateToProps, {
  onPressDashbord,
  onPressDashbordChild,
  onPressThemeColor,
  onPressGeneralSetting,
  onPressNotification,
  onPressEqualizer,
  closeHeaderMenus,
  onPressSideMenuToggle,
  onPressMenuProfileDropdown,
  onPressSideMenuTab,
  tostMessageLoad,
  updateUserInfo,
  handleLogout,
})(NavbarMenu)));
